window.atos = {
	
	askDeleteConfig: function(){
	
		var options = {
			
			type	: 'warning',
			buttons : [
				{
					text : Loc.g("Oui, effacer"), 
					click : function(){
						
						$(this).dialog("close");
						
						MyFacture.post("atos_prefs", {action:"deletepref"}, function(data){
							Utils.reload();
						}, "json");
					}
				},
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Êtes vous sur de vouloir effacer la configuration du module ATOS ?'), options);
	}
}